<template>
  <div>
    <b-row>
      <b-col align-self="center">
        <b-form-group label-align="right" :label="$t('Service name')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
          <b-form-input type="text" v-model="currentService.service_name"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Charge time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <flat-picker :key="rerenderChargeTime"
            @onDateChanged="(unixDate) => {getFreezedSlink.discount_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(getFreezedSlink.discount_date ? getFreezedSlink.discount_date : new Date()/1000 ).toDate())}"
            />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="getFreezedSlink.cost_coef"/>
        </b-form-group>
          <b-form-group label-align="right" :label="$t('Is executed')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox disabled v-model="getFreezedSlink.is_executed"/>
          </b-form-group>
      </b-col>
    </b-row>

    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null,
    tariffLinkId: 0
  },
  data () {
    return {
      rerenderChargeTime: 0,
      getFreezedSlink: {
        slink_id: 0,
        discount_date: moment().unix(),
        cost_coef: 100,
        is_executed: false
      }
    }
  },
  methods: {
    saveServiceLink () {
      let updFreezedSLink = {
        user_id: this.currentUser.user_id,
        account_id: this.selectedAccount,
        discount_date: this.getFreezedSlink.discount_date,
        service_id: this.currentService.service_id,
        cost_coef: this.getFreezedSlink.cost_coef / 100,
        service_link_id: 0
      }
      if (this.isEdit) {
        updFreezedSLink.service_link_id = this.currentService.service_link_id
      }
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_FREEZED_SERVICE_LINK', updFreezedSLink)
        : this.$store.dispatch('Users/CREATE_FREEZED_SERVICE_LINK', updFreezedSLink)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
          this.hideSelectService()
          this.$root.$emit('makeToasts')
        }
      })
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    }
  },
  mounted () {
    if (this.isEdit) {
      this.$store.dispatch('Users/GET_FREEZED_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.getFreezedSlink = this.$store.getters['Users/FREEZED_SERVICE_LINK']
        this.getFreezedSlink.cost_coef = this.getFreezedSlink.cost_coef * 100
        this.getFreezedSlink.cost = Number.parseFloat(this.getFreezedSlink.cost).toFixed(3)
        this.rerenderChargeTime += 1
      })
    }
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formFreezed.vue